import { TypePolicy } from '@apollo/client';

export const playlistTypePolicy: TypePolicy = {
  fields: {
    items: {
      merge( _existing, incoming ) {
        return incoming;
      },
    },
    applications: {
      merge( _existing, incoming ) {
        return incoming;
      },
    },
  },
};
